export interface Question {
  headline: string;
  introduction: string;
  text: string;
  answers: TestAnswer[];
  description: string;
  imageFilePath: string | null;
  exampleImageFilePath: string | null;
}

export interface TestAnswer {
  label: string;
  correct: boolean;
}

export const EmptyTestAnswer: TestAnswer = {
  label: '',
  correct: false,
};

export function getCorrectAnswer(answers: TestAnswer[]): TestAnswer {
  return answers.find((answer) => answer.correct) as TestAnswer;
}
